import Moment from "react-moment";
import moment from "moment-timezone";
import { Box } from "@mui/material";

/**
 * A timestamp, plus how long ago it was.
 *
 * "09-Apr-2026 14:26:16" on its own makes the reader do the arithmetic to work
 * out whether a record was touched yesterday or two years ago. The absolute
 * value stays first -- it is what people quote to each other and paste into
 * tickets -- followed by a muted "· 3 days ago".
 *
 * Both halves are <Moment> elements, so react-moment's shared pool refreshes
 * them on its own interval and "a minute ago" keeps ticking. Hand-formatting
 * either half would freeze it at render time.
 *
 * @param {object} props
 * @param {boolean} [props.relative=false] - Opt IN where the extra width is
 *   not affordable (a narrow grid column, say) and only the timestamp is wanted.
 */
const NiceDate = (props) => {
  const input = props.children;

  if (!input) return null;

  const dateToDisplay = moment(input);
  if (!dateToDisplay.isValid()) return null;

  const absolute = <Moment format="DD-MMM-YYYY HH:mm:ss">{dateToDisplay}</Moment>;

  if (props.relative !== true) {
    return absolute;
  }

  return (
    <Box component="span" sx={{ whiteSpace: "nowrap" }}>
      {absolute}
      <Box component="span" sx={{ color: "text.secondary", marginLeft: "0.4rem" }}>
        {"· "}
        <Moment fromNow>{dateToDisplay}</Moment>
      </Box>
    </Box>
  );
};

export default NiceDate;
